/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable object-shorthand */
import { useEffect, useState } from 'react';
import { Linking } from 'react-native';
import SnapCalorieSitePage from '../components/SnapCalorieSitePage';
import { TextWrap as Text, View, styles as sc } from '../components/Themed';
import { RootStackScreenProps } from '../navigation/navigationTypes';
// Image assets

export default function NotFoundScreen({ navigation }: RootStackScreenProps<'NotFound'>) {
  const [url, setUrl] = useState('');
  useEffect(() => {
    Linking.getInitialURL().then((thisUrl) => {
      setUrl(thisUrl ?? '');

      const urlPath = thisUrl
        ? thisUrl
            .split('/')
            .filter((val) => {
              return !!val;
            })
            .slice(-1)
        : '';
      if (urlPath.length === 1 && urlPath[0] === 'survey') {
        navigation.navigate('Survey', { id: 'ValidDevice' });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SnapCalorieSitePage
      headerLinks={{
        Home: () => {
          navigation.navigate('Home');
        },
      }}
    >
      <View
        style={{
          paddingTop: 30,
          alignSelf: 'center',
        }}
        key="ContainerView"
      >
        <Text>Requested url: {url.split('/').slice(-1)}</Text>
        <Text style={[sc.blockParagraph, { textAlign: 'center' }]}>
          The page you were trying to view could not be found.
        </Text>
        <Text style={[sc.blockParagraph, { textAlign: 'center' }]}>
          Return to the{' '}
          <a href="https://www.snapcalorie.com/home" target="_self">
            home page
          </a>
          .
        </Text>
      </View>
    </SnapCalorieSitePage>
  );
}
